// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "module." + chunkId + ".js?v=" + {"211":"6ca020e59ff43ef56aaa","212":"26ecb081bcce2be215ce","481":"aa262d4f8b18dae40942"}[chunkId] + "";
};